import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import BookContent from "@/views/editor/wiki-editor/illustrated-book/BookContent.vue";
import "./renderer.less";
// 段落
const Paragraph = {
  name: "HtmlParagraph",
  props: {
    node: {
      type: Object,
      default: () => ({})
    }
  },
  render() {
    const { $slots, node } = this;
    const { indent, textAlign, lineHeight, customClass = null, customStyle = {} } = node;
    const style = {};
    indent && (style.textIndent = indent);
    textAlign && (style.textAlign = textAlign);
    lineHeight && (style.lineHeight = lineHeight);

    return (
      <p style={{ ...style, ...customStyle }} class={customClass}>
        <span>&#xFEFF;</span>
        {$slots.default}
        <span>&#xFEFF;</span>
      </p>
    );
  }
};
// 文本
const Text = {
  name: "HtmlText",
  render() {
    const { $slots } = this;
    return <span>{$slots.default}</span>;
  }
};
// 图片
const HtmlImg = {
  name: "HtmlImg",
  props: {
    type: {
      type: String,
      default: ""
    },
    node: {
      type: Object,
      default: () => ({})
    }
  },
  render() {
    const { node } = this;
    const { src, alt, link, commentData, style, isAdaptive, verticalAlign } = node;
    if (link || commentData) {
      return (
        <div class="w-editor-image" key={Math.random()} style={{ verticalAlign }}>
          <img
            class="preview-image"
            src={src}
            alt={alt}
            style={!isAdaptive ? { ...style, maxWidth: "100%" } : { maxWidth: "100%" }}
          />
          <div class="w-editor-image-more">
            {/* 图片链接 */}
            {link && (
              <a href={link} target="_blank" title="点击跳转">
                <div class="w-editor-image-link">
                  <svg viewBox="0 0 1024 1024" p-id="29631" width="24" height="24">
                    <path
                      d="M512 0C229.23 0 0 229.23 0 512s229.23 512 512 512 512-229.23 512-512S794.77 0 512 0z m0.39 660.68a28.294 28.294 0 0 1-3.87 4.71h-0.05l-30.87 31.92c-41.81 44.55-110.64 45.62-153.73 2.38-0.21-0.21-0.42-0.42-0.62-0.63-41.55-44.8-40.79-115.74 1.7-159.58l78.92-81.55c16.16-17.06 37.22-28.25 60.04-31.92 23.56-4.03 47.75 0.34 68.58 12.4 16.1 8.81 22.24 29.45 13.71 46.09-8.52 16.64-28.48 22.99-44.58 14.17h-1.7c-8.38-4.74-18.18-6.02-27.42-3.56-9.81 1.81-18.82 6.78-25.72 14.2l-78.92 81.6c-17.32 16.38-18.5 44.18-2.66 62.08 15.85 17.9 42.73 19.13 60.04 2.75 0.92-0.88 1.81-1.79 2.66-2.75l30.87-31.92c13.1-12.41 33.21-12.41 46.3 0 12.6 8.85 15.88 26.59 7.32 39.61z m191.23-181.22c-1.54 1.74-3.14 3.43-4.79 5.06l-78.88 81.54c-25.4 26.82-62.06 38.79-97.75 31.92-15.18-3.26-29.69-9.26-42.86-17.71-14.99-10.07-19.25-30.79-9.51-46.29 9.49-15.1 28.83-19.73 43.77-10.47 0.94 0 1.7 0.79 1.7 1.75 4.8 3.09 10 5.47 15.43 7.08 14.64 2.76 29.62-2.61 39.46-14.15l78.87-81.54c17.46-16.22 18.9-44 3.21-62.05-15.69-18.05-42.55-19.54-60.01-3.32a43.106 43.106 0 0 0-3.19 3.29l-30.87 31.92c-12.79 13.22-33.52 13.22-46.3 0-12.79-13.22-12.79-34.65 0-47.88l30.87-31.92c41.81-44.55 110.64-45.62 153.73-2.39 0.21 0.21 0.42 0.42 0.62 0.63 43.07 40.83 45.98 110.01 6.5 154.53z"
                      fill="#08b0fd"
                    ></path>
                  </svg>
                </div>
              </a>
            )}
            {/* 图片注释 */}
            {commentData && (
              <div class="w-editor-image-comment">
                <el-popover placement="bottom" trigger="hover">
                  <div>
                    <WikiEditorRenderer editorData={commentData}></WikiEditorRenderer>
                  </div>
                  <span slot="reference" title="查看注释">
                    <svg viewBox="0 0 1024 1024" width="24" height="24">
                      <path
                        d="M512 56.889344c251.35104 0 455.110656 203.759616 455.110656 455.110656S763.35104 967.110656 512 967.110656 56.889344 763.35104 56.889344 512 260.64896 56.889344 512 56.889344z m224 227.555328h-448c-17.673216 0-32 14.32576-32 32v338.983936c0 17.673216 14.326784 32 32 32h27.36128l33.1264 63.8208c8.1408 15.685632 27.457536 21.80096 43.143168 13.66016a32 32 0 0 0 13.66016-13.66016l33.1264-63.8208H736c17.673216 0 32-14.326784 32-32v-338.98496c0-17.672192-14.326784-32-32-32z m-24.889344 56.88832v289.206272h-307.26144l-26.959872 51.943424-26.96192-51.943424h-37.03808V341.332992h398.221312z"
                        fill="#fbbc05"
                      ></path>
                    </svg>
                  </span>
                </el-popover>
              </div>
            )}
          </div>
        </div>
      );
    } else {
      return (
        <div class="w-editor-image" style={{ verticalAlign }}>
          <img
            class="preview-image"
            src={src}
            alt={alt}
            style={!isAdaptive ? { ...style, maxWidth: "100%" } : { maxWidth: "100%" }}
          />
        </div>
      );
    }
  }
};
// 超链接
const Link = {
  name: "HtmlLink",
  props: {
    href: {
      type: String,
      default: ""
    },
    target: {
      type: String,
      default: ""
    },
    rel: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  },
  render() {
    const { href, target, rel, title, $slots } = this;
    return (
      <a href={href} target={target} rel={rel} title={title}>
        {$slots.default}
      </a>
    );
  }
};
// 无序列表 | 有序列表
const List = {
  name: "HtmlList",
  props: {
    type: {
      type: String,
      default: ""
    },
    node: {
      type: Object,
      default: () => ({})
    }
  },
  render() {
    const { type, $slots, node } = this;
    const { indent, textAlign, lineHeight } = node;
    const style = {};
    indent && (style.textIndent = indent);
    textAlign && (style.textAlign = textAlign);
    lineHeight && (style.lineHeight = lineHeight);

    let vnode = null;
    if (type === "numbered-list") {
      vnode = <ol>{$slots.default}</ol>;
    }
    if (type === "bulleted-list") {
      vnode = <ul>{$slots.default}</ul>;
    }
    if (type === "list-item") {
      vnode = <li style={style}>{$slots.default}</li>;
    }
    return vnode;
  }
};
// 标题
const Header = {
  name: "HtmlList",
  props: {
    type: {
      type: String,
      default: ""
    },
    node: {
      type: Object,
      default: () => ({})
    }
  },
  render() {
    const { type, $slots, node } = this;
    const { indent, textAlign, lineHeight, customClass = null, customStyle = {} } = node;
    const style = {};
    indent && (style.textIndent = indent);
    textAlign && (style.textAlign = textAlign);
    lineHeight && (style.lineHeight = lineHeight);

    let vnode = null;
    if (type === "header1") {
      vnode = (
        <h1 style={{ ...style, ...customStyle }} class={customClass}>
          {$slots.default}
        </h1>
      );
    } else if (type === "header2") {
      vnode = (
        <h2 style={{ ...style, ...customStyle }} class={customClass}>
          {$slots.default}
        </h2>
      );
    } else if (type === "header3") {
      vnode = (
        <h3 style={{ ...style, ...customStyle }} class={customClass}>
          {$slots.default}
        </h3>
      );
    } else if (type === "header4") {
      vnode = (
        <h4 style={{ ...style, ...customStyle }} class={customClass}>
          {$slots.default}
        </h4>
      );
    } else if (type === "header5") {
      vnode = (
        <h5 style={{ ...style, ...customStyle }} class={customClass}>
          {$slots.default}
        </h5>
      );
    }
    return vnode;
  }
};
// 表格
const Table = {
  name: "HtmlTable",
  props: {
    index: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: ""
    },
    node: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      contentWidth: 878,
      sortType: "default", // default | asc | desc
      filterList: ["全部"],
      filterValue: "全部",
      filterData: {
        index: 0,
        rows: []
      }
    };
  },
  mounted() {
    if (this.type === "table") {
      const { key } = this.node;
      const table = document.getElementById(key);
      const flod = table.closest(".w-editor-flod");
      const tabs = table.closest(".w-editor-tabs");
      if (flod) {
        setTimeout(() => {
          this.contentWidth = flod.clientWidth - 12;
        }, 0);
      } else if (tabs) {
        setTimeout(() => {
          this.contentWidth = tabs.clientWidth - 22;
        }, 0);
      } else {
        setTimeout(() => {
          this.contentWidth = table.parentNode.clientWidth;
        }, 0);
      }
    }
  },
  render() {
    const { type, node, $slots, contentWidth, index, sortType, filterList, filterValue } = this;

    let vnode = null;
    if (type === "table") {
      const { key, noBorder, width: tableWidth, isAdaptive } = node;
      const columns = node.children[0].children || [];
      vnode = (
        <div class={`w-editor-table ${noBorder ? "no-border" : ""}`} id={key}>
          <table style={{ width: isAdaptive ? contentWidth + "px" : tableWidth }}>
            <colgroup>
              {columns.map(col => {
                const { width = "100px" } = col;
                let w = parseInt(width);
                if (isAdaptive) {
                  w = parseInt((w * contentWidth) / parseInt(tableWidth));
                }
                return <col width={w + "px"}></col>;
              })}
            </colgroup>
            <tbody>{$slots.default}</tbody>
          </table>
        </div>
      );
    } else if (type === "table-row") {
      const { height } = node;
      vnode = (
        <tr style={{ height: height || 32 }} data-sort-default={index}>
          {$slots.default}
        </tr>
      );
    } else if (type === "table-cell") {
      const { colSpan, rowSpan, bgColor, borderColor, isMerged, hasSort, hasFilter, width } = node;
      const isCollapsed = isMerged || colSpan === 0 || rowSpan === 0;

      vnode = isCollapsed ? null : (
        <td
          colSpan={colSpan}
          rowSpan={rowSpan}
          style={{ display: isCollapsed ? "none" : undefined, backgroundColor: bgColor, width: width }}
          onClick={e => {
            if (hasSort) {
              this.sortType = this.sortType == "default" ? "asc" : this.sortType == "asc" ? "desc" : "default";
              this.sortColumn(index, e);
            } else if (hasFilter) {
              this.openFilter(index, e);
            }
          }}
        >
          {$slots.default}
          {borderColor ? <div class="cell-border top" style={{ background: borderColor[0] }}></div> : null}
          {borderColor ? <div class="cell-border right" style={{ background: borderColor[1] }}></div> : null}
          {borderColor ? <div class="cell-border bottom" style={{ background: borderColor[2] }}></div> : null}
          {borderColor ? <div class="cell-border left" style={{ background: borderColor[3] }}></div> : null}
          {(hasSort || hasFilter) && (
            <div class="table-cell__srot_filter">
              {hasSort && (
                <div class="table-cell__srot">
                  {sortType !== "desc" && (
                    <svg viewBox="0 0 1024 1024" width="8" height="8">
                      <path d="M960 704L512 256l-448 448z" fill="#262626" p-id="36841"></path>
                    </svg>
                  )}
                  {sortType !== "asc" && (
                    <svg viewBox="0 0 1024 1024" width="8" height="8">
                      <path d="M64 320l448 448 448-448z" fill="#262626" p-id="36989"></path>
                    </svg>
                  )}
                </div>
              )}
              {hasFilter && (
                <div class="table-cell__srot">
                  <el-dropdown trigger="click" onCommand={command => this.filterColumn(command)}>
                    <span ref="dropdownRef">
                      <svg viewBox="0 0 1024 1024" width="14" height="14">
                        <path
                          d="M807.6 167.9c-5.8-5.1-13-7.5-20.1-7.4-1.6-0.2-3.3-0.5-5-0.5H133c-16 0-29 13-29 29.1 0 7.9 3.2 15 8.2 20.3l226.4 254.4v289.9c0 13.3 9 24.6 21.2 28l180.8 79.8c3.8 1.7 7.8 2.4 11.8 2.4 11.2 0 21.8-6.4 26.7-17.3 1.9-4.4 2.7-8.9 2.4-13.2V465.7L810.1 209c10.6-12 9.5-30.4-2.5-41.1z"
                          p-id="38103"
                        ></path>
                        <path
                          d="M646.8 532.1c0 16.1 13 29.1 29.1 29.1h215c16.1 0 29.1-13 29.1-29.1S907 503 890.9 503h-215c-16 0-29.1 12.9-29.1 29.1zM890.9 639.9h-215c-16.1 0-29.1 13-29.1 29.1s13 29.1 29.1 29.1h215c16.1 0 29.1-13 29.1-29.1 0-16-13-29.1-29.1-29.1z m0 137.1h-215c-16.1 0-29.1 13-29.1 29.1s13 29.1 29.1 29.1h215c16.1 0 29.1-13 29.1-29.1S907 777 890.9 777z"
                          p-id="38104"
                        ></path>
                      </svg>
                    </span>
                    <el-dropdown-menu slot="dropdown" style={{ maxWidth: "200px" }}>
                      {filterList.map(item => {
                        return (
                          <el-dropdown-item
                            command={item}
                            title={item}
                            disabled={filterValue === item}
                            style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}
                          >
                            {item}
                          </el-dropdown-item>
                        );
                      })}
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              )}
            </div>
          )}
          <div></div>
        </td>
      );
    }
    return vnode;
  },
  methods: {
    sortColumn(index, e) {
      const target = e.target;
      const table = target.closest("table");
      const tbody = table.querySelector("tbody");
      // const tbodyCopy = tbody.cloneNode(true);
      const rows = Array.from(tbody.children);
      console.log(target, table, rows);
      const sortRows = rows.slice(1);
      sortRows.sort((aRow, bRow) => {
        const aCell = aRow.children[index];
        const bCell = bRow.children[index];
        const aCellText = aCell.innerText.trim();
        const bCellText = bCell.innerText.trim();
        const aNumber = Number(aCellText);
        const bNumber = Number(bCellText);
        const a = isNaN(aNumber) ? aCellText : aNumber;
        const b = isNaN(bNumber) ? bCellText : bNumber;
        const aRowDefault = Number(aRow.getAttribute("data-sort-default"));
        const bRowDefault = Number(bRow.getAttribute("data-sort-default"));
        if (this.sortType === "asc") {
          return a < b ? -1 : a > b ? 1 : 0;
        } else if (this.sortType === "desc") {
          return a > b ? -1 : a < b ? 1 : 0;
        } else {
          return aRowDefault - bRowDefault;
        }
      });
      console.log(sortRows.map(row => row.children[index].innerText));
      const newTobody = document.createElement("tbody");
      newTobody.appendChild(rows[0]);
      sortRows.forEach(row => {
        newTobody.appendChild(row);
      });
      table.replaceChild(newTobody, tbody);
    },
    openFilter(index, e) {
      if (this.filterList.length === 1) {
        const target = e.target;
        const table = target.closest("table");
        const tbody = table.querySelector("tbody");
        // const tbodyCopy = tbody.cloneNode(true);
        const rows = Array.from(tbody.children);
        console.log(target, table, rows);
        const filterRows = rows.slice(1);
        filterRows.forEach(row => {
          const cell = row.children[index];
          const cellText = cell.innerText.trim();
          if (cellText && !this.filterList.includes(cellText)) {
            this.filterList.push(cellText);
          }
        });

        this.filterData = {
          index,
          table: table
        };
      }
      this.$refs.dropdownRef.click();
    },
    filterColumn(command) {
      this.filterValue = command;
      const { index, table } = this.filterData;
      const tbody = table.querySelector("tbody");
      // const tbodyCopy = tbody.cloneNode(true);
      const rows = Array.from(tbody.children);

      const filterRows = rows.slice(1);

      filterRows.forEach(row => {
        const cell = row.children[index];
        const cellText = cell.innerText.trim();

        if (command === "全部") {
          row.style.display = "table-row";
        } else if (cellText === command) {
          row.style.display = "table-row";
        } else {
          row.style.display = "none";
        }
      });

      const newTobody = document.createElement("tbody");
      newTobody.appendChild(rows[0]);
      filterRows.forEach(row => {
        newTobody.appendChild(row);
      });
      table.replaceChild(newTobody, tbody);
    }
  }
};
// 分割线
const Divider = {
  name: "HtmlDivider",
  props: {
    type: {
      type: String,
      default: ""
    },
    node: {
      type: Object,
      default: () => ({})
    }
  },
  render() {
    const { type, node, $slots } = this;
    const { value } = node;

    let vnode = null;
    if (type === "divider") {
      vnode = <div class={`w-editor-divider ${value}`}>{$slots.default}</div>;
    }

    return vnode;
  }
};

// 页签
const Tabs = {
  name: "HtmlTabs",
  props: {
    type: {
      type: String,
      default: ""
    },
    node: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      active: 0
    };
  },
  render() {
    const { type, node, $slots } = this;

    let vnode = null;
    if (type === "tabs") {
      const { children = [] } = node;
      vnode = (
        <div class={`w-editor-tabs`}>
          <div class="w-editor-tabs-header" contentEditable={false}>
            <div class="w-editor-tabs-nav">
              {children.map((item, index) => {
                return (
                  <div
                    key={item.key}
                    class={`w-editor-tabs-nav-item ${this.active === index ? "active" : ""}`}
                    onClick={e => this.handleActive(e, index)}
                    title={item.title}
                  >
                    {item.title}
                  </div>
                );
              })}
            </div>
          </div>
          <div class="w-editor-tabs-content">
            {$slots.default.map((child, index) => {
              return (
                <div class="w-editor-tabs-panel" style={{ display: this.active === index ? "block" : "none" }}>
                  {child}
                </div>
              );
            })}
          </div>
        </div>
      );
    } else if (type === "tab-item") {
      vnode = (
        <div class={`w-editor-tab-item-container`}>
          {$slots.default}
          <div></div>
        </div>
      );
    }
    return vnode;
  },
  methods: {
    handleActive(e, index) {
      this.active = index;
    }
  }
};
// 视频
const Video = {
  name: "HtmlVideo",
  props: {
    type: {
      type: String,
      default: ""
    },
    node: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      iframeHtml: ""
    };
  },
  mounted() {
    const { node } = this;
    const { src, width, height } = node;
    if (src.trim().indexOf("<iframe ") === 0) {
      this.iframeHtml = this.setSizeStyleToIframeHtml(src, width, height);
    }
  },
  render() {
    const { type, node, $slots } = this;

    let vnode = null;
    if (type === "video") {
      const { src, poster, width, height } = node;
      if (src.trim().indexOf("<iframe ") === 0) {
        // iframe 形式，第三方视频
        vnode = (
          <div class={`w-editor-video`}>
            {/* 内嵌第三方 iframe 视频 */}
            <span contentEditable="false" domPropsInnerHTML={this.iframeHtml}></span>
            {$slots.default}
          </div>
        );
      } else {
        // 其他，mp4 格式
        const videoVnode = (
          <video
            poster={poster}
            controls
            style={{
              // eslint-disable-next-line
              width: width ? width : undefined,
              // eslint-disable-next-line
              height: height ? height : undefined
            }}
          >
            <source src={src} type="video/mp4" />
            {`Sorry, your browser doesn't support embedded videos.\n 抱歉，浏览器不支持 video 视频`}
          </video>
        );

        vnode = (
          <div class={`w-editor-video`}>
            {videoVnode}
            {$slots.default}
          </div>
        );
      }
    }
    return vnode;
  },
  methods: {
    setSizeStyleToIframeHtml(src, width, height) {
      const $div = document.createElement("div");
      $div.innerHTML = src;
      const $iframe = $div.getElementsByTagName("iframe")[0];
      const iframeSrc = $iframe.getAttribute("src");

      const url = new window.URL(iframeSrc.startsWith("http") ? iframeSrc : "http:" + iframeSrc);
      url.searchParams.append("autoplay", 0);
      $iframe.setAttribute("src", url.href.replace(/^(http|https):/g, ""));
      // eslint-disable-next-line
      width ? ($iframe.style.width = width) : "";
      // eslint-disable-next-line
      height ? ($iframe.style.height = height) : "";

      return $iframe.outerHTML;
    }
  }
};

// 音频
const Audio = {
  name: "HtmlAudio",
  props: {
    type: {
      type: String,
      default: ""
    },
    node: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isPlaying: 0
    };
  },
  render() {
    const { type, node, $slots } = this;

    let vnode = null;
    if (type === "audio") {
      const { src } = node;
      vnode = (
        <div class="w-editor-audio">
          <div class="audio-player">
            <audio
              ref="audioRef"
              src={src}
              onTimeUpdate={this.handleTimeUpdate}
              onLoadedMetadata={this.handleLoadedMetadata}
              onEnded={this.handleEnded}
            />
            <div class="controls">
              <button class="play-button" onClick={e => this.togglePlay(e)}>
                {this.isPlaying ? (
                  <i class="icon">
                    <svg viewBox="0 0 1024 1024">
                      <path d="M289.7 962c-65.6 0-118.8-53.2-118.8-118.8V180.8c0-65.6 53.2-118.8 118.8-118.8s118.8 53.2 118.8 118.8v662.4c0 65.6-53.2 118.8-118.8 118.8zM734.3 962c-65.6 0-118.8-53.2-118.8-118.8V180.8c0-65.6 53.2-118.8 118.8-118.8s118.8 53.2 118.8 118.8v662.4c0 65.6-53.2 118.8-118.8 118.8z"></path>
                    </svg>
                  </i>
                ) : (
                  <i class="icon">
                    <svg viewBox="0 0 1024 1024" style={{ marginLeft: 4 }}>
                      <path d="M833.308444 599.096889l-558.478222 380.017778c-45.738667 31.118222-106.837333 17.351111-136.476444-30.776889a107.690667 107.690667 0 0 1-15.815111-56.32V131.982222C122.538667 74.752 166.741333 28.273778 221.240889 28.273778c19.000889 0 37.603556 5.802667 53.589333 16.668444l558.478222 379.960889c45.738667 31.118222 58.823111 95.345778 29.240889 143.473778-7.566222 12.288-17.578667 22.755556-29.240889 30.72z"></path>
                    </svg>
                  </i>
                )}
              </button>
              {/* <div class="time">
          {formatTime(currentTime)} / {formatTime(duration)}
        </div> */}
            </div>
          </div>
          {$slots.default}
        </div>
      );
    }
    return vnode;
  },
  methods: {
    togglePlay(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.$refs.audioRef) {
        const $audio = this.$refs.audioRef;
        if (this.isPlaying) {
          $audio.pause();
        } else {
          $audio.play();
        }
        this.isPlaying = !this.isPlaying;
      }
    },
    handleEnded() {
      this.isPlaying = false;
    },

    handleTimeUpdate() {
      if (this.$refs.audioRef) {
        // const $audio = this.$refs.audioRef;
      }
    },

    handleLoadedMetadata() {
      if (this.$refs.audioRef) {
        // const $audio = this.$refs.audioRef;
      }
    }
  }
};

// 折叠模块
const Flod = {
  name: "HtmlFlod",
  props: {
    type: {
      type: String,
      default: ""
    },
    node: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isExpanded: false
    };
  },
  render() {
    const { type, node, $slots } = this;

    let vnode = null;
    if (type === "flod") {
      const { title, themeColor } = node;
      vnode = (
        <div class="w-editor-flod">
          <div class="flod-box" style={{ borderColor: themeColor || "#e3e3e3" }}>
            <div class="flod-title" contentEditable={false}>
              <div
                class="expand-collapse-btn"
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.isExpanded = !this.isExpanded;
                }}
              >
                {this.isExpanded ? (
                  <svg viewBox="0 0 1024 1024">
                    <path d="M64 576h896V448H64z"></path>
                  </svg>
                ) : (
                  <svg viewBox="0 0 1024 1024">
                    <path d="M576 64H448v384H64v128h384v384h128V576h384V448H576z"></path>
                  </svg>
                )}
              </div>
              <span>{title}</span>
            </div>
            <div class={`flod-content${this.isExpanded ? " expanded" : " collapsed"}`}>
              {$slots.default}
              <div></div>
            </div>
          </div>
        </div>
      );
    }
    return vnode;
  },
  methods: {}
};

// 注释内容
const PopoverComment = {
  name: "HtmlPopoverComment",
  props: {
    type: {
      type: String,
      default: ""
    },
    node: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {};
  },
  render() {
    const { type, node, $slots } = this;

    let vnode = null;
    if (type === "popover-comment") {
      const { data } = node;
      vnode = (
        <span>
          <el-popover placement="bottom" trigger="hover">
            <div>
              <WikiEditorRenderer editorData={data}></WikiEditorRenderer>
            </div>
            <span slot="reference" style={{ cursor: "pointer", color: "#5db3e6" }}>
              {$slots.default}
            </span>
          </el-popover>
        </span>
      );
    }

    return vnode;
  }
};

// 图片集
const ImageAlbum = {
  name: "HtmlImageAlbum",
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    type: {
      type: String,
      default: ""
    },
    node: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      swiperOptions: {
        initialSlide: 0,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
        // pagination: {
        //   el: ".img-view-pagination",
        //   type: "fraction"
        // }
      },
      swiperOptionThumbs: {
        initialSlide: 0,
        spaceBetween: 10,
        slidesPerView: 5,
        // freeMode: true,
        // watchSlidesVisibility: true,
        // watchSlidesProgress: true,
        slideToClickedSlide: true,
        centeredSlides: true,
        navigation: {
          nextEl: ".swiper-thumbs-next",
          prevEl: ".swiper-thumbs-prev"
        }
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.$swiper;
      const swiperThumbs = this.$refs.swiperThumbs.$swiper;
      // swiperThumbs.thumbs.swiper = swiperTop
      swiperTop.controller.control = swiperThumbs;
      swiperThumbs.controller.control = swiperTop;
    });
  },
  render() {
    const { type, node, $slots } = this;

    let vnode = null;
    if (type === "image-album") {
      const { data = [] } = node;
      vnode = (
        <div class={`w-editor-image-album`}>
          <div class="image-album-box">
            <Swiper class="swiper" ref="swiperTop" autoDestroy={true} autoUpdate={true} options={this.swiperOptions}>
              {data.map((src, index) => {
                return (
                  <SwiperSlide class="swiper-slide" key={index} zoom={true}>
                    <img src={src} alt="" class="swiper-lazy preview-image" />
                  </SwiperSlide>
                );
              })}
            </Swiper>

            <div class="thumbs">
              <Swiper class="swiper-thumbs" ref="swiperThumbs" options={this.swiperOptionThumbs}>
                {data.map((src, index) => {
                  return (
                    <SwiperSlide class="swiper-slide" key={index} zoom={true}>
                      <img src={src} alt="" class="swiper-lazy preview-image" />
                    </SwiperSlide>
                  );
                })}
              </Swiper>
              {/* <div class="swiper-thumbs-prev "></div>
              <div class="swiper-thumbs-next"></div> */}
            </div>
          </div>

          {$slots.default}
        </div>
      );
    }

    return vnode;
  }
};

const WikiEditorRenderer = {
  name: "WikiEditorRenderer",
  components: {},
  props: {
    editorData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {},
  render() {
    // 渲染文本样式
    const renderStyleText = data => {
      let vnode = data.text || "\uFEFF";
      if (data.bold) {
        vnode = <strong>{vnode}</strong>;
      }
      if (data.italic) {
        vnode = <em>{vnode}</em>;
      }
      if (data.underline) {
        vnode = <u>{vnode}</u>;
      }
      if (data.through) {
        vnode = <s>{vnode}</s>;
      }
      return vnode;
    };

    const renderLeaf = item => {
      const { color, bgColor, fontSize } = item;
      const style = {};
      color && (style.color = color);
      bgColor && (style.backgroundColor = bgColor);
      fontSize && (style.fontSize = fontSize);

      return <Text style={style}>{renderStyleText(item)}</Text>;
    };

    const renderElement = (children = []) => {
      if (Array.isArray(children) && children.length == 0) {
        return [];
      }
      return children.map((item, index) => {
        let vnode = null;
        if (item.type) {
          switch (item.type) {
            case "image-album":
              vnode = (
                <ImageAlbum type={item.type} node={item}>
                  {renderElement(item.children)}
                </ImageAlbum>
              );
              break;
            case "popover-comment":
              vnode = (
                <PopoverComment type={item.type} node={item}>
                  {renderElement(item.children)}
                </PopoverComment>
              );
              break;
            case "flod":
              vnode = (
                <Flod type={item.type} node={item}>
                  {renderElement(item.children)}
                </Flod>
              );
              break;
            case "audio":
              vnode = (
                <Audio type={item.type} node={item}>
                  {renderElement(item.children)}
                </Audio>
              );
              break;
            case "video":
              vnode = (
                <Video type={item.type} node={item}>
                  {renderElement(item.children)}
                </Video>
              );
              break;
            case "tabs":
            case "tab-item":
              vnode = (
                <Tabs type={item.type} node={item}>
                  {renderElement(item.children)}
                </Tabs>
              );
              break;
            case "divider":
              vnode = (
                <Divider type={item.type} node={item}>
                  {renderElement(item.children)}
                </Divider>
              );
              break;
            case "table":
            case "table-row":
            case "table-cell":
              vnode = (
                <Table index={index} type={item.type} node={item}>
                  {renderElement(item.children)}
                </Table>
              );
              break;
            case "header1":
            case "header2":
            case "header3":
            case "header4":
            case "header5":
              vnode = (
                <Header type={item.type} node={item}>
                  {renderElement(item.children)}
                </Header>
              );
              break;
            case "numbered-list":
            case "bulleted-list":
            case "list-item":
              vnode = (
                <List type={item.type} node={item}>
                  {renderElement(item.children)}
                </List>
              );
              break;
            case "image":
              vnode = <HtmlImg key={index} type={item.type} node={item}></HtmlImg>;
              break;
            case "link":
              vnode = (
                <Link href={item.url} target={item.target || "_blank"} rel={item.rel} title={item.title}>
                  {renderElement(item.children)}
                </Link>
              );
              break;
            case "paragraph":
              vnode = <Paragraph node={item}>{renderElement(item.children)}</Paragraph>;
              break;
            case "illustrated-book":
              vnode = (
                <div class="w-editor-illustrated-book">
                  <BookContent contentData={item.data} mode="view"></BookContent>
                </div>
              );
              break;
            default:
              vnode = null;
          }
        } else {
          vnode = renderLeaf(item);
        }

        return vnode;
      });
    };
    return (
      <div class="wiki-editor-content">
        {renderElement(this.editorData || [])}
        <div></div>
      </div>
    );
  }
};
export default WikiEditorRenderer;
